import React from "react";
import AccountCircleRounded from "@mui/icons-material/AccountCircleRounded";
import styles from "./CheckoutRecentSalesPopup.module.scss";
import { useCheckoutRecentSalesPopup } from "./CheckoutRecentSalesPopup.utils";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";

const CheckoutRecentSalesPopup = () => {
    const { listingType, enableRecentSalesPopup } =
        useCheckoutBasicDetailsContext();
    const { show, actionText, lastPurchaseTimeGap, peopleCount } =
        useCheckoutRecentSalesPopup({
            listingType,
            enablePopup: enableRecentSalesPopup,
        });

    if (!show) return null;

    return (
        <div className={styles.Wrapper}>
            <div className={styles.Container}>
                <div className={styles.IconColumn}>
                    <svg width={0} height={0}>
                        <linearGradient
                            id="paint0_linear_1717_2781"
                            x1="18.0001"
                            y1="2.99997"
                            x2="18.0001"
                            y2="33"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#48CA93" />
                            <stop offset="1" stopColor="#48BACA" />
                        </linearGradient>
                    </svg>
                    <AccountCircleRounded
                        className={styles.IconStyle}
                        style={{ fill: "url(#paint0_linear_1717_2781)" }}
                    />
                </div>
                <div className={styles.ContentColumn}>
                    <div className={styles.peopleCountText}>
                        {`${peopleCount} people ${actionText} this offering`}
                    </div>
                    <div className={styles.lastPurchaseTimeText}>
                        {`In last ${lastPurchaseTimeGap} minutes!`}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutRecentSalesPopup;
